import React from 'react';
import { space } from 'styled-system';
import styled from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledCol = styled.div(({ col }) => {
  if (!col) {
    return {
      flex: "1 0 0%",
      minWidth: 0
    };
  }
  return {
    flex: "0 0 auto",
    width: `${col / 12 * 100}%`,
    paddingRight: "0.5rem",
    paddingLeft: "0.5rem"
  };
}, space);
const Col = (_a) => {
  var _b = _a, {
    children,
    col
  } = _b, props = __objRest(_b, [
    "children",
    "col"
  ]);
  return /* @__PURE__ */ React.createElement(StyledCol, __spreadValues({
    col
  }, props), children);
};

export { Col };
